

import React from 'react';
import styled from 'styled-components';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, ReferenceLine, BarChart, Bar,
  ReferenceDot, Tooltip, CartesianGrid, Legend, Brush, ErrorBar, AreaChart, Area, Rectangle,
  Label, LabelList } from 'recharts';

  const stackedColor = (idx) => {
    return ['red','orange','green','blue','violet'][idx % 5];
  }


const ChartBlock = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #ccc;
  padding: 20px;
`;

const ChartBlockTitle = styled.div`
  font-size: 21px;
  padding-left: 20px;
  max-width: 400px;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-family: AvenirNext-DemiBold;
  text-align: center;
`;

const ChartBlockTitlePrimary = styled(ChartBlockTitle)`
  font-size: 25px;
`;

const ChartBlockTitleSecondary = styled(ChartBlockTitle)`
  font-size: 21px;
`;

const RetentionChart = ({
  title,
  data,
  isPrimary,
}) => {
  const formattedData = new Array(4);
  Object.keys(data).forEach(key => {
    [data[key].first,...data[key].counts].forEach((count,idx) => {
      const myArray = formattedData[idx] || [];
      myArray['periods'] = idx + 1;
      myArray[key] = count / data[key].first;
      formattedData[idx] = myArray;
    })
  });

  return (
    <ChartBlock>
      {
        title && isPrimary && <ChartBlockTitlePrimary>{title} </ChartBlockTitlePrimary>
      }
      {
        title && !isPrimary && <ChartBlockTitleSecondary>{title} </ChartBlockTitleSecondary>
      }
      <LineChart width={500} height={350} data={formattedData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="periods" />
        <YAxis />
        <Tooltip />
        <Legend />
        {
          Object.keys(formattedData[0]).filter(key=> key != 'periods').map((key, idx)=> {
            return <Line type="monotone" dataKey={key} stroke={stackedColor(idx)}/>
          })
        }
      </LineChart>
    </ChartBlock>
  );
}

export default RetentionChart;